import { MarkerConstants } from '../_constants';

const initialState = {
  loading: false,
  error: undefined,
  items: [],
  params: undefined,
};

export function markerTypes(state = initialState, action) {
  switch (action.type) {
    case MarkerConstants.FETCH_MARKER_TYPES_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }

    case MarkerConstants.FETCH_MARKER_TYPES_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        error: undefined,
        items: payload,
      };
    }

    case MarkerConstants.FETCH_MARKER_TYPES_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
      };
    }

    default: {
      return state;
    }
  }
}
